import { Component } from '@angular/core'
import { FacetListComponent } from '@spartacus/storefront'
import { EbFacet } from '../../../interfaces/eb-product.interface'
import { EbFacetComponent } from '../facet/eb-facet.component'

@Component({
    selector: 'eb-facet-list',
    templateUrl: './eb-facet-list.component.html',
    styleUrls: ['./eb-facet-list.component.scss'],
    standalone: false
})
export class EbFacetListComponent extends FacetListComponent {
  rememberedScrollPosition: { code: string; targetY: number }

  beforeFacetChange(code: string, y: number) {
    this.rememberedScrollPosition = { code, targetY: y }
  }

  onFacetCreation(facet: EbFacet, component: EbFacetComponent) {
    if (this.rememberedScrollPosition?.code === facet.code) {
      this.restoreScrollPosition(component.getScrollPosition)
    }
    return facet
  }

  restoreScrollPosition(sourceY: number) {
    const { targetY } = this.rememberedScrollPosition
    if (sourceY && sourceY !== targetY) {
      scrollBy({ top: sourceY - targetY })
      this.rememberedScrollPosition = undefined
    }
  }
}
